import { render, staticRenderFns } from "./supplierSupplyList.vue?vue&type=template&id=b1e842d4&scoped=true"
import script from "./supplierSupplyList.vue?vue&type=script&lang=js"
export * from "./supplierSupplyList.vue?vue&type=script&lang=js"
import style0 from "./supplierSupplyList.vue?vue&type=style&index=0&id=b1e842d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e842d4",
  null
  
)

export default component.exports